export default {
  familyName: 'Barlow',
  fullName: 'Barlow SemiBold',
  postscriptName: 'Barlow-SemiBold',
  category: 'sans-serif',
  capHeight: 700,
  ascent: 1000,
  descent: -200,
  lineGap: 0,
  unitsPerEm: 1000,
  xHeight: 511,
  xWidthAvg: 439,
  subsets: {
    latin: {
      xWidthAvg: 439
    },
    thai: {
      xWidthAvg: 454
    }
  }
};
